module.exports = __webpack_public_path__ + "img/clothing43.39b833a6.jpg";